import React from 'react';

const Basic = ({ children, ...props }) => {
  return (
    <div {...props}>
      {children}
    </div>
  );
};

export default Basic;
